import { Component } from '@angular/core';
import "@maersk-global/mds-components-core/mc-card";
import { Router } from '@angular/router';
import { deleteAllCookies, getSortName, getDisplayName } from '../shared/lib/utilities';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class FailedComponent {
  constructor(private router:Router, private authService:MsalService) {

  }
  login(){
    deleteAllCookies();
    localStorage.clear();
    this.authService.logout();
    this.router.navigate(['login']);
  }
} 
